import Vue from 'vue'
import VueRouter from 'vue-router'
import List from '../views/List.vue'
import Attending from '../views/Attending.vue'
import Home from '../views/Students.vue'
import Admin from '../views/Admin.vue'
import West from '../views/West.vue'
import East from '../views/East.vue'
import Joke from '../views/Joke.vue'
import Faq from '../views/Faq.vue'
import Precautions from '../views/Precautions.vue'
import Survey from '../views/Survey.vue'
import Slideshow from '../views/Slideshow.vue'
import Reunion from '../views/Reunion.vue'
import _layout from '../views/_layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: _layout,
    children: [
      {
        path: '/',
        name: 'List',
        component: List
      },
      {
        path: '/attending',
        name: 'Attending',
        component: Attending
      },
      {
        path: '/west',
        name: 'West',
        component: West
      },
      {
        path: '/east',
        name: 'East',
        component: East
      },
      {
        path: '/faq',
        name: 'Faq',
        component: Faq
      },
      {
        path: '/survey',
        name: 'Survey',
        component: Survey
      },
      {
        path: '/precautions',
        name: 'Precautions',
        component: Precautions
      },
      {
        path: '/reunion',
        name: 'Reunion',
        component: Reunion
      },
      {
        path: '/admin',
        name: 'Admin',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Admin
      },
      {
        path: '/payment',
        redirect: to => {
          console.log('here we arer')
          window.location.href = 'https://www.paypal.com/paypalme/PKirkpatrick435'
          setTimeout(() => {
            return '/redirect'

          }, 1000)
        }
      }
    ]
  },
  {
    path: '/slideshow',
    name: 'Slideshow',
    component: Slideshow
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    //const top = 500 // document.querySelector('#top').getBoundingClientRect().top
    //console.log(top)
    //return { x: 0, y: top }
    return {
      selector: '#top',
      behavior: 'smooth',
    }
  }
})

export default router
